import styled from "styled-components";

export const SideContainer = styled.g`
  cursor: pointer;
`;
